module.exports = __webpack_public_path__ + "static/media/hide.4dcede19.png";